<mat-card appearance="outlined">
    <mat-card-content *ngIf="isLoaded" fxLayout="row" fxLayoutAlign="space-between start" [formGroup]="formGroup">
        <div fxFlex="50" fxLayout="column" fxLayoutAlign="space-between stretch">
            <lgd-radio-group *ngIf="hasSeparateTotals" controlName="accountType" label="Account Type" style="margin-bottom: 1rem;" [horizontal]="true" [options]="accountTypes" telemetry="Submission-AccountType">
            </lgd-radio-group>

            <ng-container *ngIf="hasAccount">
                <div fxFlex="11" fxLayout="row">
                    <span fxFlex="60">Original Budget</span>
                    <span fxFlex="40" class="numeric">{{BudgetOriginal | currency}}</span>
                </div>

                <div fxFlex="11" fxLayout="row" class="mt10">
                    <span fxFlex="60">Budget Adjustment</span>
                    <span fxFlex="40" class="numeric">{{BudgetAdjustment | currency}}</span>
                </div>

                <mat-divider class="mt10"></mat-divider>

                <div fxFlex="11" fxLayout="row" class="mt10">
                    <span fxFlex="60">{{currentBudgetLabel}}</span>
                    <span fxFlex="40" class="numeric">{{CurrentBudget | currency}}</span>
                </div>

                <div fxFlex="11" fxLayout="row" class="mt10">
                    <span fxFlex="60">Activity</span>
                    <span fxFlex="40" class="numeric">
                        <a *ngIf="showLink" (click)="drillDownOnActivity($event)" aria-label="Redirect-Activity">
                            {{Activity | currency}}
                        </a>
                        <ng-container *ngIf="!showLink">{{Activity | currency}}</ng-container>
                    </span>
                </div>

                <div fxFlex="11" fxLayout="row" class="mt10">
                    <span fxFlex="60">Encumbrance</span>
                    <span fxFlex="40" class="numeric">
                        <a *ngIf="showLink" (click)="drillDownOnEncumbrances($event)" aria-label="Redirect-Encumbrance">
                            {{Encumbrance | currency}}
                        </a>
                        <ng-container *ngIf="!showLink">{{Encumbrance | currency}}</ng-container>
                    </span>
                </div>

                <div fxFlex="11" fxLayout="row" class="mt10">
                    <span fxFlex="60">Reserve</span>
                    <span fxFlex="40" class="numeric">
                        <a *ngIf="showLink" (click)="drillDownOnReserves($event)" aria-label="Redirect-Reserves">
                            {{Reserves | currency}}
                        </a>
                        <ng-container *ngIf="!showLink">{{Reserves | currency}}</ng-container>
                    </span>
                </div>

                <div fxFlex="11" fxLayout="row" class="mt10">
                    <span fxFlex="60">Prior Year Adjustment</span>
                    <span fxFlex="40" class="numeric">{{PriorYearAdjustment | currency}}</span>
                </div>

                <mat-divider class="mt10"></mat-divider>

                <div fxFlex="11" fxLayout="row" class="mt10">
                    <span fxFlex="60">{{budgetRemainingLabel}}</span>
                    <span fxFlex="40" class="numeric">{{BudgetRemaining | currency}}</span>
                </div>

                <div fxFlex="11" fxLayout="row" class="mt10">
                    <span fxFlex="60">{{pendingLabel}}</span>
                    <span fxFlex="40" class="numeric">{{Pending | currency}}</span>
                </div>

                <mat-divider class="mt10"></mat-divider>

                <div fxFlex="11" fxLayout="row" class="mt10">
                    <span fxFlex="60">{{budgetAvailableLabel}}</span>
                    <span fxFlex="40" class="numeric">{{BudgetAvailable | currency}}</span>
                </div>
            </ng-container>
        </div>

        <account-detail-pie-chart fxFlex="45" [account]="chartData | async" [appName]="link">
        </account-detail-pie-chart>

    </mat-card-content>
</mat-card>
